/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

// import * as Msdyn365 from '@msdyn365-commerce/core';

import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    // ICommerceApiSettings,
    ICreateActionContext
} from '@msdyn365-commerce/core';

import { getStockAvailDateAsync } from './DataService/DataActionExtension.g'; //getStockAvailDateAsync, getPromiseDateAsync
import { ICalculateStockAvailDateResponse } from './DataService/DataServiceEntities.g';
// import { getStockAvailQtyInput } from './DataService/DataServiceEntities.g';
import { ParseAvailabilyDate } from '../utilities/parse-availability-date';
/**
 * Getstockavaildate Input Action
 */
export class GetStockAvailDateInput implements IActionInput {
    // TODO: Construct the input needed to run the action
    public accountNum: number;
    public catalogId: number;
    public itemId: string;
    public dispositionCode: string;
    public quantity: number;

    constructor(
        accountNum: number | string,
        catalogId: number | string,
        itemId: string,
        dispositionCode: string,
        quantity: number | string
    ) {
        this.accountNum = typeof accountNum === 'string' ? +accountNum : accountNum;
        this.catalogId = typeof catalogId === 'string' ? +catalogId : catalogId;
        this.itemId = itemId;
        this.dispositionCode = dispositionCode;
        this.quantity = typeof quantity === 'string' ? +quantity : quantity;
    }
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetStockAvailDateInput`;
    public getCacheObjectType = () => 'GetStockAvailDateInput';
    public dataCacheType = (): CacheType => 'none';
}

// // TODO: Create a data model here or import one to capture the response of the action
// export interface IGetstockavaildateData {
//     text: string;
// }

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (
    args: ICreateActionContext,
    accountNum: number | string,
    catalogId: number | string,
    itemId: string,
    dispositionCode: string,
    quantity: number | string
): IActionInput => {
    return new GetStockAvailDateInput(accountNum, catalogId, itemId, dispositionCode, quantity);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function GetStockAvailDate(input: GetStockAvailDateInput, ctx: IActionContext): Promise<ICalculateStockAvailDateResponse> {
    return getStockAvailDateAsync(
        { callerContext: ctx },
        input.itemId,
        input.quantity,
        input.accountNum,
        input.catalogId,
        input.dispositionCode
    )
        .then(data => {
            data.DateAvail = ParseAvailabilyDate(data.DateAvail);
            return data;
        })
        .catch(error => {
            ctx.telemetry.exception(error);
            ctx.trace('[get-stock-avail-qty] Unable to load stock total');
            throw new Error('[get-stock-avail-qty] Unable to load stock total');
        });
}

export default createObservableDataAction({
    action: <IAction<ICalculateStockAvailDateResponse>>GetStockAvailDate,
    // TODO: Give your data action a unique id
    id: 'GetStockAvailDate',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
